<template>
  <Teleport :to="'#bk-toolbar-' + region">
    <button
      ref="el"
      class="bk-toolbar-button"
      :disabled="disabled"
      :class="[{ 'is-active': active }, id ? 'bk-is-' + id : void 0]"
      :style="{ order: weight || 0 }"
      @click.prevent.stop="onClick"
    >
      <slot>
        <Icon v-if="icon" :name="icon" />
      </slot>
      <div class="bk-tooltip">
        <span>{{ title }}</span>
        <ShortcutIndicator
          v-if="keyCode"
          :meta="meta"
          :shift="shift"
          :key-code="keyCode"
          :label="title"
          :group="shortcutGroup"
          @pressed="onClick"
        />
      </div>
    </button>
  </Teleport>
</template>

<script setup>
import { ShortcutIndicator, Icon } from "#blokkli/components";
import { ref } from "#imports";
import defineCommands from "#blokkli/helpers/composables/defineCommands";
import defineTourItem from "#blokkli/helpers/composables/defineTourItem";
const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
  region: { type: String, required: true },
  editOnly: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false },
  active: { type: Boolean, required: false },
  meta: { type: Boolean, required: false },
  shift: { type: Boolean, required: false },
  keyCode: { type: String, required: false },
  icon: { type: null, required: false },
  shortcutGroup: { type: String, required: false },
  tourText: { type: String, required: false },
  weight: { type: [Number, String], required: false }
});
const emit = defineEmits(["click"]);
const el = ref(null);
function onClick() {
  if (props.disabled) {
    return;
  }
  emit("click");
}
defineCommands(() => {
  return {
    id: "plugin:toolbar_button:" + props.id,
    label: props.title,
    group: "ui",
    icon: props.icon,
    disabled: props.disabled,
    callback: () => emit("click")
  };
});
defineTourItem(() => {
  if (!props.tourText) {
    return;
  }
  return {
    id: "plugin:toolbar-button:" + props.id,
    title: props.title,
    text: props.tourText,
    element: () => el.value
  };
});
</script>

<script>
export default {
  name: "PluginToolbarButton"
};
</script>
